import React from "react";
import List from "./List";
import {useRoutes} from "hookrouter";
import {addSection, removeSection, updateSection, useSection} from "../../../../../Api/competitions";
import debug from "../../../../../Lib/debug";
import Form from "./Form";
import {SectionRecord, SectionSchema} from "../../../../../Data/Competition";
import {useTranslation} from "react-i18next";

export default (props) => useRoutes(subRoutes)(props)

const subRoutes = {
  "/": () => (props) => <Participations view="list" {...props}/>,
  "/add": () => (props) => <Participations view="add" {...props}/>,
  "/:id/edit": ({id}) => (props) => <Participations view="edit" {...props} id={id}/>,
  "/:id/remove": ({id}) => (props) => <Participations view="remove" {...props} id={id}/>
};


const Participations = ({view, id, competitionId, path}) => {

  debug("RENDER", "Competitions.Sections", () => []);

  const {loadingStatus, data} = useSection(competitionId, id);

  const prefix = "/admin/competitions/" + competitionId + "/sections/";

  const viewData = (loadingStatus ? new SectionRecord(SectionSchema.default()) : data);

  const {t} = useTranslation('competition');

  const label = (view === 'add' ? t('add-section') : viewData.get('name'));

  const np = path.slice(0); // to avoid modifying parent path

  switch (view) {
    case "list" :

      return <List competitionId={competitionId} path={np}/>;

    case "add" :

      np.push({label: label, url: prefix + "add"});
      return <Form competitionId={competitionId} id={id} record={viewData.set('competition', competitionId)} path={np} view={view} api={addSection}/>;

    case "remove" :

      np.push({label: label, url: prefix + id + "/remove"});
      return <Form competitionId={competitionId} id={id} record={viewData} path={np} view={view} api={removeSection}/>;

    case "edit" :

      np.push({label: label, url: prefix + id + "/edit"});
      return <Form competitionId={competitionId} id={id} record={viewData} path={np} view={view} api={updateSection}/>;

    default :
      return <div>invalid view: {view}</div>
  }
};